class CookieConsentManager {
    static enable(service) {
        return localStorage.setItem('cookieconsent_' + service, '1');
    }

    static hasConsent(service) {
        if (window.name === 'neos-content-main') {
            return true;
        }

        return localStorage.getItem('cookieconsent_' + service) === '1';
    }

    /*
     * Executes the callback, after we got consent
     */
    static onHasConsent(service, callback) {
        if (CookieConsentManager.hasConsent(service)) {
            callback();
        } else {
            setTimeout(() => CookieConsentManager.onHasConsent(service, callback), 200);
        }
    }
}

window.CookieConsentManager = CookieConsentManager;
